var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"matchup-container"},[_c('div',{staticClass:"defender-block"},[_vm._t("defender-info")],2),_vm._l((_vm.matchupSpread),function({ effectiveness, types }){return _c('div',{key:effectiveness,staticClass:"matchup-result",style:({
			'grid-area': `x${effectiveness}`.replace(
				'.',
				'dot',
			),
		})},[_c('span',{staticClass:"matchup-effectiveness"},[_vm._v("x"+_vm._s(effectiveness))]),_c('div',{staticClass:"type-stack"},_vm._l((types),function(type){return _c('type-block',{key:type,attrs:{"type":type}})}),1)])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }